import React from "react";
import { Link } from "react-router-dom";
import { trackClick } from "../telemetry";

import "./our_team_page.css";

import Logo from "../assets/composiq-mark-128.png";
const JoeAvatar = "/images/joe.villarino.irl.jpeg";
const NevinAvatar = "/images/nevin.nilanont.irl.jpg";
const MauraAvatar = "/images/maura.hagen.irl.jpeg";
const MarieAvatar = "/images/marie.villarino.irl.jpg";

export default function OurTeamPage(){
  const [mobileOpen, setMobileOpen] = React.useState(false);

  /* ── Header gains its hairline once the page is scrolled ── */
  const [headerScrolled, setHeaderScrolled] = React.useState(false);
  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    let raf = 0;
    const update = () => { raf = 0; setHeaderScrolled(window.scrollY > 4); };
    const onScroll = () => { if (!raf) raf = window.requestAnimationFrame(update); };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (raf) window.cancelAnimationFrame(raf);
    };
  }, []);

  const teamMembers = [
    { id: "joe", name: "Joe Villarino", role: "CEO", img: JoeAvatar, photoStyle: { width: "100%", height: "100%", objectFit: "cover", display: "block" }, wrapStyle: { width: "96px", height: "105px", borderRadius: "12px" } },
    { id: "nevin", name: "Nevin Nilanont", role: "CTO", img: NevinAvatar, photoStyle: { width: "100%", height: "100%", objectFit: "cover", display: "block", objectPosition: "center 34%", transform: "scale(1.52) translateY(-14%)", transformOrigin: "center 16%" }, wrapStyle: { width: "96px", height: "105px", borderRadius: "12px" } },
    { id: "maura", name: "Maura Hagen", role: "President & COO", img: MauraAvatar, photoStyle: { width: "100%", height: "auto", display: "block", marginTop: "-25px" }, wrapStyle: { width: "96px", height: "auto", borderRadius: "12px" } },
    { id: "marie", name: "Marie Villarino", role: "Chief Compliance Officer (CCO)", img: MarieAvatar, photoStyle: { width: "100%", height: "100%", objectFit: "cover", display: "block" }, wrapStyle: { width: "96px", height: "105px", borderRadius: "12px" } }
  ];

  return (
    <div className="App team-page">
      {/* ───────── HEADER (match Home) ───────── */}
      <header className={`dbx-header${headerScrolled ? ' is-scrolled' : ''}`} role="banner">
        <div className="dbx-header-inner">
          <Link to="/" className="dbx-brand" aria-label="Zerivo home">
            <img className="dbx-brand-mark" src={Logo} alt="" />
            <div className="dbx-brand-text-group">
              <span className="dbx-brand-text">Zerivo</span>
              <span className="dbx-brand-subtitle">Private AI</span>
            </div>
          </Link>

          <div className="dbx-header-right">
            <nav className="dbx-header-nav" aria-label="Main navigation">
              <Link to="/our-team">Our Team</Link>
              <Link to="/contact">Contact</Link>
            </nav>

            <div className="dbx-header-actions">
              <a
                href="https://portal.azure.com/#view/Microsoft_Azure_Marketplace/MarketplaceOffersBlade/selectedMenuItemId/home"
                className="dbx-btn header-cta"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackClick("Get Zerivo on Azure", { placement: "header", page: "our-team" })}
              >
                Get Zerivo on Azure
              </a>
            </div>
          </div>

        </div>
      </header>

      {mobileOpen && (
        <nav className="dbx-mobile-nav" role="navigation" aria-label="Mobile navigation">
          <button className="dbx-mobile-close" onClick={() => setMobileOpen(false)} aria-label="Close menu">×</button>
          <Link to="/our-team" onClick={() => setMobileOpen(false)}>Our Team</Link>
          <Link to="/contact" onClick={() => setMobileOpen(false)}>Contact</Link>
          <Link to="/privacy" onClick={() => setMobileOpen(false)}>Privacy</Link>
          <Link to="/terms" onClick={() => setMobileOpen(false)}>Terms</Link>
        </nav>
      )}
      {mobileOpen && <div className="dbx-mobile-backdrop" onClick={() => setMobileOpen(false)} aria-hidden="true"></div>}

      {/* ───────── MAIN CONTENT ───────── */}
      <main className="team-wrapper">
        <section className="team-hero" aria-labelledby="team-title">
          <h1 id="team-title" className="team-title">Meet the Team</h1>
          <p className="team-sub">Builders, designers, and operators focused on secure, usable AI for regulated teams.</p>

          <div className="team-strip" role="region" aria-label="Team photos">
            {teamMembers.map(m => (
              <div key={m.id} className="team-member">
                <div className="team-photo-wrap" aria-hidden="true" style={m.wrapStyle}>
                  <img className="team-photo" src={m.img} alt="" style={m.photoStyle} />
                </div>
                <div className="team-name">{m.name}</div>
                <div className="team-role">{m.role}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="team-copy">
          <p>
            Our background spans public-sector innovation, data engineering, and product design in regulated environments—from healthcare and finance to government services.
          </p>
          <p>
            We've built complex systems under real oversight, so "no data leaves the boundary" isn't a slogan to us—it's an engineering requirement. Zerivo exists to give institutions private AI inside their tenant, with audit evidence and support that make rollout, review, and expansion possible without compromising compliance or control.
          </p>
        </section>
      </main>
    </div>
  );
}


